import { render, staticRenderFns } from "./EventShow.vue?vue&type=template&id=5bc76013"
import script from "./EventShow.vue?vue&type=script&lang=js"
export * from "./EventShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports